var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("a-table", {
    attrs: {
      size: "small",
      "data-source": _vm.dtReport,
      columns: _vm.columns,
      scroll: { x: 3200 },
      loading: _vm.loading,
      pagination: {
        showTotal: function() {
          return _vm.$t("lbl_total_items", {
            total: _vm.dtReport.length
          })
        },
        total: _vm.dtReport.length,
        showSizeChanger: true,
        pageSizeOptions: _vm.PAGE_SIZE_OPTIONS
      },
      "row-class-name": function(_record, index) {
        return index % 2 ? "bg-white" : "bg-gray-light"
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }